import React from "react";
import TableCard from "./TableCard";
import {useTranslation} from "react-i18next";
import {useProjectDetailsForm} from "../hooks";
import {ROLES_PROPERTY_NAMES} from "../../../utils/constants";
import {withErrorBoundary} from "../../../components/ErrorBoundary";
import FormControlsButtons from "../../../components/FormControlButtons";
import {ARInputWithLabel} from "../../../components/ReactHookForm/fields";
import {CCard, CCardBody, CCardFooter, CCardHeader, CForm} from "@coreui/react";
import {
  convertItemsForTable,
  getGroupsTableColumnHeaders,
  getGroupsTableFilterText,
  getMembersTableColumnHeaders,
  getMembersTableFilterText
} from "./TableCard/TableCard.model";

const ProjectDetails = () => {
  const {t} = useTranslation();
  const {
    Prompt,
    roles,
    formControl,
    projectInfo,
    updateRoles,
    onFormReset,
    onFormSubmit,
    onFormDelete,
    showGroupsModal,
    showMembersModal,
  } = useProjectDetailsForm();

  const {header, isMainProject} = projectInfo;
  const {handleSubmit, control} = formControl;

  return (
    <CCard className="ProjectDetailsCard">
      <CCardHeader className="ProjectDetailsCard__header">
        <h1 className="ProjectDetailsCard__header-text card-header-text">
          {header}
        </h1>
      </CCardHeader>
      <CCardBody className="ProjectDetailsCard__body">
        <Prompt/>
        <CForm id="project-edit-form" onSubmit={handleSubmit(onFormSubmit)}>
          <ARInputWithLabel
            id="name"
            name="name"
            control={control}
            autoComplete="off"
            disabled={isMainProject}
            labelText={t("form:label.projectName", "Project name")}
            placeholder={t("form:placeholder.projectName", "Enter project's name")}
          />
        </CForm>
      </CCardBody>
      <CCardFooter className="ProjectDetailsCard__footer">
        <FormControlsButtons
          className="mr-3"
          form="project-edit-form"
          onCancelClick={onFormReset}
          disabled={isMainProject}
          onDeleteClick={isMainProject ? null : onFormDelete}
        />
      </CCardFooter>
      <CCard className="mr-3 ml-3">
        <CCardBody>
          <TableCard
            items={convertItemsForTable(roles.members, ROLES_PROPERTY_NAMES.members.singular)}
            rolePropertyNames={ROLES_PROPERTY_NAMES.members}
            getTableFilterText={getMembersTableFilterText}
            updateRoles={updateRoles}
            headerText={t("card.title.members", "Members")}
            fields={getMembersTableColumnHeaders()}
            addRowClickCallback={showMembersModal}
            className={`${!roles.members?.length && "border-bottom"} mb-3 pb-1`}
            isMainProject={isMainProject}
          />
          <TableCard
            items={convertItemsForTable(roles.groups, ROLES_PROPERTY_NAMES.groups.singular)}
            rolePropertyNames={ROLES_PROPERTY_NAMES.groups}
            getTableFilterText={getGroupsTableFilterText}
            updateRoles={updateRoles}
            headerText={t("card.title.groups", "Groups")}
            fields={getGroupsTableColumnHeaders()}
            addRowClickCallback={showGroupsModal}
          />
        </CCardBody>
      </CCard>
    </CCard>
  );
};

export default withErrorBoundary(ProjectDetails);